module.exports = __webpack_public_path__ + "static/커피시리얼-6632b9a0b0d1f030c7998606db406151.jpg";